import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { formatText } from 'src/utils/era-package'

/**
 * @param data {Array} - Array of data objects to be displayed in the table
 * @param columns {Array} - Array of column definitions, each in the shape `{header: string, name: string, type?: string}`, where name is the data key, header is the display string, and type is one of the formats defined in 'src/utils/era-package'
 */
export const BasicTable = ({
  data = [], columns = [], TableProps = {},
  onRowClick,
}) => {
  const { container = {}, ...props } = TableProps
  return <TableContainer {...container}>
    <Table size='small' {...props}>
      <TableHead><TableRow>
        {columns.map(({ header }, i) => <TableCell key={i} sx={{
          fontWeight: 600,
          color: 'primary.main'
        }}>
          {header}
        </TableCell>)}
      </TableRow></TableHead>
      <TableBody>
        {(data ?? []).map((row, i) => (
          <TableRow
            key={row.id || i}
            hover={!!onRowClick}
            onClick={() => onRowClick?.(row)}
            sx={{ cursor: onRowClick ? 'pointer' : 'default' }}
          >
            {columns.map(({ name, type }) => (
              <TableCell key={name}>
                {formatText(row[name], type, row)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
}